<template>
  <v-container>
    <v-data-table-server
      v-model:items-per-page="pagination.limit"
      :items="formTemplates"
      :headers="headers"
      :items-length="count"
      :loading="loading"
      :search="pagination.q"
      item-key="id"
      @update:options="handleLimitChange">
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          :to="{ name: 'AdminFormTemplateDetail', params: { formTemplateId: item.id } }"
          router
          small
          color="primary">
          Edit
        </v-btn>
      </template>
      <template v-slot:top>
        <v-text-field
          v-model="pagination.q"
          class="ma-2"
          density="compact"
          placeholder="Search forms..."
          hide-details></v-text-field>
      </template>
    </v-data-table-server>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { IPaginationDTO, PaginationDTO } from '@/dtos';
import type { VDataTableServer } from 'vuetify/components';
import { useFormTemplateStore } from '@/stores/modules';

const formTemplateStore = useFormTemplateStore();
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const headers = [
  { title: 'Name', key: 'name' },
  { title: 'Edit', key: 'action' },
];
const formTemplates = computed(() => formTemplateStore.formTemplatePaginationQuery.data);
const loading = computed(() => formTemplateStore.formTemplatePaginationQuery.isLoading);
const count = computed(() => formTemplates.value?.length ?? 0);

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
  formTemplateStore.pagination = pagination.value;
};
</script>
